import { ReductionBase } from './reductionBase';

export default class ReductionWeb extends ReductionBase {
  constructor(props) {
    super(props);
  }
}
